module.exports = __webpack_public_path__ + "img/pålestikk_double4.d034c3c1.jpg";